import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function SecureImage({ fileId, alt, className }: { fileId?: string | null; alt: string; className?: string }) {
  const [src, setSrc] = useState<string>("");
  useEffect(() => {
    if (!fileId) return;
    let url = "";
    api.get(`/files/${fileId}`, { responseType: "blob" }).then((r) => { url = URL.createObjectURL(r.data); setSrc(url); }).catch(() => setSrc(""));
    return () => { if (url) URL.revokeObjectURL(url); };
  }, [fileId]);
  if (!fileId) return null;
  if (!src) return <div className={`animate-pulse rounded-xl bg-slate-200 ${className || ""}`} data-testid="secure-image-loading" />;
  return <img src={src} alt={alt} className={className} data-testid="secure-image" />;
}
